export function compactThumbnailCaption(
  seriesNumber: string | number,
  description: string
): string {
  return `S:${seriesNumber} · ${description}`;
}

export function shouldShowInstanceCount(numInstances: number): boolean {
  return numInstances > 1;
}

// 60px image + 42px caption + 4px gap + 8px vertical padding = 114px.
// Keep the compact study-browser tile within the April-feedback 115px limit.
export const compactThumbnailTileClass = 'h-[114px] w-[120px]';
